import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTheme } from "@mui/material";


export default function CardMarkerSmall(props) {

  const theme = useTheme();
  const {headline, subtext, list, add, info, addtextright, cardlines, sx: sxProp } = props

return(

<Card variant="outlined" sx={[{  width: '100%',
                                height: 'auto',
                                bgcolor: theme.palette.mode === "light" ? 'grey.C50' : 'greydark.C970',
                                border: 'none',
                                borderRadius: 4,
                                m: { xs: 0, sm: 2 },
                                p:1
                                }, ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : [])]}>
  <CardContent>

      <Grid container>   
     
            <Grid size={12}> <Typography variant="h4" textAlign='left' gutterBottom> {headline} </Typography>  </Grid>
            <Grid size={12}> <Typography variant="subtitle2" textAlign='left' gutterBottom sx={{pl: 0.5, fontWeight: 400,  }}>{subtext} </Typography>  </Grid>
            <Grid size={5} sx={{mb:2, display:'flex', justifyContent:'left' }}><Stack direction="row"> {list} {add} {info} </Stack></Grid>
            <Grid size={6} sx={{m:1, display:'flex', justifyContent:'right', alignItems: 'center' }}>{addtextright} </Grid>
            <Grid size={12}>{ cardlines }</Grid>  

     </Grid>        

  </CardContent>

</Card>

)}
